var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fileGenericBasicForm"},[_c('p',{staticClass:"fileGenericBasicForm__hint"},[_vm._v("上传资源文件后，扩展字段由后端处理写入。")])])
}]

export { render, staticRenderFns }